module.exports = __webpack_public_path__ + "img/fire-smoke-source-1.036b8b32.png";